import { createContext, useContext } from "react";

export const CategoriesContext = createContext(undefined);

export const useCategoriesContext = () => {
  const context = useContext(CategoriesContext);

  if (!context) {
    throw new Error("CategoriesContext is not provided");
  }

  return context;
};
